import React, { useState } from "react";
import "../Pages/CSS/Faq.css";

const faqData = [
  {
    question: "Do I need to create a member account?",
    answer: `You can browse our website and add items to your basket without creating an account, and place the order with guest checkout. Creating a member account provides the following benefits:
    - Making shopping process easier
    - Save delivery addresses
    - View all previous orders from your account
    - Check your order status before it’s shipped`
  },
  {
    question: "What if I forget my password?",
    answer: `Click on 'Forgot Your Password' at the login/sign-up page. Enter your email and follow the instructions to reset your password.`
  },
  {
    question: "How can I update or edit my shipping/billing address?",
    answer: `Login to 'My Account'. You can update your shipping/billing information and save for future orders. You can also update your password from there.`
  },
  {
    question: "How do I order online?",
    answer: `Select the product, size/color, and add to cart. Click 'Proceed to Checkout' and provide valid shipping details. Select Cash on Delivery (COD) as payment and click 'Place Order'.`
  },
  {
    question: "How do I know that my order is placed?",
    answer: `After placing your order, a confirmation email with order summary and invoice will be sent to your registered email. If not received, the order might not be placed successfully.`
  },
  {
    question: "Why does the item in my cart say it is unavailable?",
    answer: `Items are available until purchased. If unavailable at checkout, remove the item from cart to continue. Contact our support if needed.`
  },
  {
    question: "Can I cancel my order?",
    answer: `You can cancel/update items in cart before placing the order. Once confirmed, orders cannot be changed before dispatch.`
  },
  {
    question: "How can I pay on your site?",
    answer: `Only Cash On Delivery (COD) is available in Pakistan. Do not pay before courier arrives. No online payment accepted for COD.`
  },
  {
    question: "How secure is my personal information?",
    answer: `Your personal and payment information is safe and secure using SSL encryption. Look for the padlock icon in your browser for verification.`
  },
  {
    question: "What currency do you use?",
    answer: `All prices are in Pakistani Rupee (PKR) including GST.`
  },
  {
    question: "How long will my order take to be delivered?",
    answer: `Shipping within Pakistan takes 7 working days. International shipping takes 14 working days after VAT confirmation.`
  }
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2>Frequently Asked Questions (FAQ)</h2>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <div
              className="faq-question"
              onClick={() => toggleIndex(index)}
            >
              {item.question}
              <span className="faq-toggle">{activeIndex === index ? "-" : "+"}</span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">{item.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
